export const toggleSideBar = () => {
  return {
    type: "TOGGLE_SIDEBAR",
  };
};

export const setSessionVar = (key, value) => {
  return {
    type: "SET_SESSION_VAR",
    key,
    value,
  };
};

export const clearSessionVars = (key, value) => {
  return {
    type: "CLEAR_SESSION_VARS",
  };
};

// TRACKER MAP STATUS -- DATA TYPE IS BOOL
export const setTrackerMapLoading = (data) => {
  return {
    type: "TRACKER_MAP_IS_LOADING",
    data,
  };
};

export const setTrackerMapError = (data) => {
  return {
    type: "TRACKER_MAP_ERROR",
    data,
  };
};

export const updateLegacySessionKey = (data) => {
  return {
    type: "SET_LEGACY_SESSION_KEY",
    data,
  };
};

export const setAccessToken = (data) => {
  return {
    type: "SET_ACCESS_TOKEN",
    data,
  };
};

export const setRefreshToken = (data) => {
  return {
    type: "SET_REFRESH_TOKEN",
    data,
  };
};

export const setLoginFailure = (data) => {
  return {
    type: "LOGIN_FAILURE",
    data,
  };
};

export const setRefreshTokenInvalid = (bool) => {
  return {
    type: "SET_TOKENS_INVALID",
    bool,
  };
};

export const setCampaignList = (data) => {
  return {
    type: "SET_CAMPAIGN_LIST",
    data,
  };
};

export const setFocusedCampaign = (data) => {
  return {
    type: "SET_FOCUSED_CAMPAIGN",
    data,
  };
};

//AGGREGATES
export const clearCampaignAggCache = (data) => {
  return {
    type: "CLEAR_CAMPAIGN_AGG_CACHE",
    data,
  };
};

export const updateCampaignAggData = (data) => {
  return {
    type: "UPDATE_AGG_DATA",
    data,
  };
};

export const setAggregatesLoading = (data) => {
  return {
    type: "SET_AGGREGATES_LOADING",
    data,
  };
};

export const setAggregatesError = (data) => {
  return {
    type: "SET_AGGREGATES_ERROR",
    data,
  };
};

export const setResponseAggregateError = (bool) => {
  return {
    type: "SET_RESPONSE_AGG_ERROR",
    data: bool,
  };
};

export const setResponseAggregateLoading = (bool) => {
  return {
    type: "SET_RESPONSE_AGG_LOADING",
    data: bool,
  };
};

export const setResponseAggregateData = (data) => {
  return {
    type: "SET_RESPONSE_AGG_DATA",
    data,
  };
};

// CAMPAIGNS

export const setCampaignsLoading = (data) => {
  return {
    type: "SET_CAMPAIGNS_LOADING",
    data,
  };
};

export const setCampaignSubAggregates = (ctx, rows) => {
  return {
    type: "SET_CAMPAIGN_SUBAGGS",
    ctx,
    rows,
  };
};

export const updateCampaign = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_CAMPAIGN",
      data,
    };
  } else {
    return {
      type: "UPDATE_CAMPAIGN",
      data,
    };
  }
};

export const insertCampaign = (data) => {
  return {
    type: "INSERT_CAMPAIGN",
    data,
  };
};

export const setCampaignsError = (data) => {
  return {
    type: "SET_CAMPAIGN_ERROR",
    data,
  };
};

// PERMISSIONS

export const setGroups = (data) => {
  return {
    type: "SET_GROUPS",
    data,
  };
};

export const setMemberships = (memberships, account) => {
  return {
    type: "SET_MEMBERSHIPS",
    memberships,
    account,
  };
};

export const setGroupsLoading = (data) => {
  return {
    type: "SET_GROUPS_LOADING",
    data,
  };
};

export const setGroupsError = (data) => {
  return {
    type: "SET_GROUPS_ERROR",
    data,
  };
};

export const setUserGroupsLoading = (data) => {
  return {
    type: "SET_USER_GROUPS_LOADING",
    data,
  };
};

export const setUserGroupsError = (data) => {
  return {
    type: "SET_USER_GROUPS_ERROR",
    data,
  };
};

//SITES
export const clearCampaignSitesCache = (data) => {
  return {
    type: "CLEAR_SITES_CACHE",
    data,
  };
};

export const setCampaignSites = (data) => {
  return {
    type: "SET_CAMPAIGN_SITES",
    data,
  };
};

export const setCampaignSitesLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_SITES_LOADING",
    data,
  };
};

export const setCampaignSitesError = (data) => {
  return {
    type: "SET_CAMPAIGN_SITES_ERROR",
    data,
  };
};

export const insertSite = (data) => {
  return {
    type: "INSERT_SITE",
    data,
  };
};

export const updateSite = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_SITE",
      data,
    };
  } else {
    return {
      type: "UPDATE_SITE",
      data,
    };
  }
};

//SITE CANVASSES
export const clearSiteCanvassCache = (data) => {
  return {
    type: "CLEAR_SITE_CANVASS_CACHE",
    data,
  };
};

export const setCampaignSiteCanvasses = (data) => {
  return {
    type: "SET_CAMPAIGN_SITE_CANVASSES",
    data,
  };
};

export const setCampaignSiteCanvassesLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_SITE_CANVASSES_LOADING",
    data,
  };
};

export const updateSiteCanvass = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_SITE_CANVASS",
      data,
    };
  } else {
    return {
      type: "UPDATE_SITE_CANVASS",
      data,
    };
  }
};

export const insertSiteCanvass = (data) => {
  return {
    type: "INSERT_SITE_CANVASS",
    data,
  };
};

export const setCampaignSiteCanvassesError = (data) => {
  return {
    type: "SET_CAMPAIGN_SITE_CANVASSES_ERROR",
    data,
  };
};

//SURVEYS

export const setCampaignSurveys = (data) => {
  return {
    type: "SET_CAMPAIGN_SURVEYS",
    data,
  };
};

export const setCampaignSurveysLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_SURVEYS_LOADING",
    data,
  };
};

export const updateSurvey = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_SURVEY",
      data,
    };
  }
  return {
    type: "UPDATE_SURVEY",
    data,
  };
};

export const insertSurvey = (data) => {
  return {
    type: "INSERT_SURVEY",
    data,
  };
};

export const setCampaignSurveysError = (data) => {
  return {
    type: "SET_CAMPAIGN_SURVEYS_ERROR",
    data,
  };
};

//SITE ROUTES

export const clearSiteRoutesCache = (data) => {
  return {
    type: "CLEAR_SITEROUTES_CACHE",
    data,
  };
};

export const setSiteRoutes = (data) => {
  return {
    type: "SET_SITE_ROUTES",
    data,
  };
};

export const removeSiteRoute = (data) => {
  return {
    type: "REMOVE_SITE_ROUTE",
    data,
  };
};

export const insertSiteRoute = (data) => {
  return {
    type: "INSERT_SITE_ROUTE",
    data,
  };
};

export const setSiteRoutesLoading = (data) => {
  return {
    type: "SET_SITE_ROUTES_LOADING",
    data,
  };
};

export const setSiteRoutesError = (data) => {
  return {
    type: "SET_SITE_ROUTES_ERROR",
    data,
  };
};

export const updateSiteRoute = (data) => {
  return {
    type: "UPDATE_SITE_ROUTE",
    data,
  };
};

export const insertRouteSeat = (data) => {
  return {
    type: "INSERT_ROUTE_SEAT",
    data,
  };
};

export const reorderRouteSeats = (data) => {
  return {
    type: "REORDER_ROUTE_SEATS",
    data,
  };
};

export const updateRouteSeatSiteOrder = (data) => {
  return {
    type: "UPDATE_ROUTE_SEAT_SITE_ORDER",
    data,
  };
};

export const deleteRouteSeat = (data) => {
  return {
    type: "DELETE_ROUTE_SEAT",
    data,
  };
};

export const insertRouteSeatSite = (data) => {
  return {
    type: "INSERT_ROUTE_SEAT_SITE",
    data,
  };
};

export const updateRouteSeatSite = (data) => {
  return {
    type: "UPDATE_ROUTE_SEAT_SITE",
    data,
  };
};

export const removeRouteSeatSite = (data) => {
  return {
    type: "REMOVE_ROUTE_SEAT_SITE",
    data,
  };
};

//OFFICES

export const clearCampaignOfficeCache = (data) => {
  return {
    type: "CLEAR_OFFICE_CACHE",
    data,
  };
};

export const setCampaignOffices = (data) => {
  return {
    type: "SET_CAMPAIGN_OFFICES",
    data,
  };
};

export const updateOffice = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_OFFICE",
      data,
    };
  } else {
    return {
      type: "UPDATE_OFFICE",
      data,
    };
  }
};

export const insertOffice = (data) => {
  return {
    type: "INSERT_OFFICE",
    data,
  };
};

export const setCampaignOfficesLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_OFFICES_LOADING",
    data,
  };
};

export const setCampaignOfficesError = (data) => {
  return {
    type: "SET_CAMPAIGN_OFFICES_ERROR",
    data,
  };
};

// ALERTS

export const setAlerts = (data) => {
  return {
    type: "SET_ALERTS",
    data,
  };
};

export const setAlertsLoading = (data) => {
  return {
    type: "SET_ALERTS_LOADING",
    data,
  };
};

export const setAlertsError = (data) => {
  return {
    type: "SET_ALERTS_ERROR",
    data,
  };
};

//CANVASSERS
export const clearCampaignCanvassersCache = (data) => {
  return {
    type: "CLEAR_CANVASSERS_CACHE",
    data,
  };
};

export const setCampaignCanvassers = (data) => {
  return {
    type: "SET_CAMPAIGN_CANVASSERS",
    data,
  };
};

export const setCampaignCanvassersLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_CANVASSERS_LOADING",
    data,
  };
};

export const updateCanvasser = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_CANVASSER",
      data,
    };
  } else {
    return {
      type: "UPDATE_CANVASSER",
      data,
    };
  }
};

export const insertCanvasser = (data) => {
  return {
    type: "INSERT_CANVASSER",
    data,
  };
};

export const setCampaignCanvassersError = (data) => {
  return {
    type: "SET_CAMPAIGN_CANVASSERS_ERROR",
    data,
  };
};

// CANVASSER EVENTS

export const setReportCanvasserEventsLoading = (data) => {
  return {
    type: "SET_REPORT_CANVASSER_EVENTS_LOADING",
    data,
  };
};

export const setReportCanvasserEventsError = (data) => {
  return {
    type: "SET_REPORT_CANVASSER_EVENTS_ERROR",
    data,
  };
};

export const setReportCanvasserEvents = (data) => {
  return {
    type: "SET_REPORT_CANVASSER_EVENTS",
    data,
  };
};

export const setReportCanvasserBreadcrumbs = (data) => {
  return {
    type: "SET_REPORT_CANVASSER_BREADCRUMBS",
    data,
  };
};

export const clearReportCanvasserEvents = (data = []) => {
  return {
    type: "CLEAR_REPORT_CANVASSER_EVENTS",
    data,
  };
};

//USERS

export const setUsers = (data) => {
  return {
    type: "SET_USERS",
    data,
  };
};

export const setInactiveUsers = (data) => {
  return {
    type: "SET_INACTIVE_USERS",
    data,
  };
};

export const setUsersLoading = (data) => {
  return {
    type: "SET_USERS_LOADING",
    data,
  };
};

export const updateUser = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_USER",
      data,
    };
  } else {
    return {
      type: "UPDATE_USER",
      data,
    };
  }
};

export const makeInactiveUserActive = (data) => {
  return {
    type: "MAKE_INACTIVE_USER_ACTIVE",
    data,
  };
};

export const insertUser = (data) => {
  return {
    type: "INSERT_USER",
    data,
  };
};

export const setUsersError = (data) => {
  return {
    type: "SET_USER_ERROR",
    data,
  };
};

// CREWS
export const setCrews = (data) => {
  return {
    type: "SET_CREWS",
    data,
  };
};

export const setCrewsShiftData = (data) => {
  return {
    type: "SET_CREWS_SHIFT_DATA",
    data,
  };
};

export const setCrewsLoading = (data) => {
  return {
    type: "SET_CREWS_LOADING",
    data,
  };
};

export const setCrewsError = (data) => {
  return {
    type: "SET_CREWS_ERROR",
    data,
  };
};

export const insertCrew = (data) => {
  return {
    type: "INSERT_CREW",
    data,
  };
};

export const updateCrew = (data) => {
  return {
    type: "UPDATE_CREW",
    data,
  };
};

//data is crew id
export const removeCrew = (data) => {
  return {
    type: "REMOVE_CREW",
    data,
  };
};

//SCRIPTS

export const setCampaignScripts = (data) => {
  return {
    type: "SET_CAMPAIGN_SCRIPTS",
    data,
  };
};

export const updateScript = (data) => {
  if (data.is_active === false || data.is_active === 0) {
    return {
      type: "REMOVE_SCRIPT",
      data,
    };
  } else {
    return {
      type: "UPDATE_SCRIPT",
      data,
    };
  }
};

export const insertScript = (data) => {
  return {
    type: "INSERT_SCRIPT",
    data,
  };
};

export const setCampaignScriptsLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_SCRIPTS_LOADING",
    data,
  };
};

export const setCampaignScriptsError = (data) => {
  return {
    type: "SET_CAMPAIGN_SCRIPTS_ERROR",
    data,
  };
};

// INFO TILE

export const setInfoFeedMessage = (data) => {
  return {
    type: "SET_INFO_FEED_MESSAGE",
    data,
  };
};

export const removeInfoFeedMessage = (data) => {
  return {
    type: "REMOVE_INFO_FEED_MESSAGE",
    data,
  };
};

export const clearAllMessages = () => {
  return {
    type: "CLEAR_ALL",
  };
};

// DOORS STUFF

//DOOR CANVASSES

export const clearDoorCanvassCache = () => {
  return {
    type: "CLEAR_DOOR_CANVASS_CACHE",
  };
};

export const setCampaignDoorCanvasses = (data) => {
  return {
    type: "SET_CAMPAIGN_DOOR_CANVASSES",
    data,
  };
};

export const updateDoorCanvass = (data) => {
  return {
    type: "UPDATE_DOOR_CANVASS",
    data,
  };
};

export const removeDoorCanvass = (data) => {
  return {
    type: "REMOVE_DOOR_CANVASS",
    data,
  };
};

export const insertDoorCanvass = (data) => {
  return {
    type: "INSERT_DOOR_CANVASS",
    data,
  };
};

export const setCampaignDoorCanvassesLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_DOOR_CANVASSES_LOADING",
    data,
  };
};

export const setCampaignDoorCanvassesError = (data) => {
  return {
    type: "SET_CAMPAIGN_DOOR_CANVASSES_ERROR",
    data,
  };
};

//DOOR CANVASS PASSES

export const clearDoorCanvassPassCache = () => {
  return {
    type: "CLEAR_DOOR_CANVASS_PASS_CACHE",
  };
};

export const setCampaignDoorCanvassPasses = (data) => {
  return {
    type: "SET_DOOR_CANVASS_PASSES",
    data,
  };
};

export const updateDoorCanvassPass = (data) => {
  return {
    type: "UPDATE_DOOR_CANVASS_PASS",
    data,
  };
};

export const removeDoorCanvassPass = (data) => {
  return {
    type: "REMOVE_DOOR_CANVASS_PASS",
    data,
  };
};

export const insertDoorCanvassPass = (data) => {
  return {
    type: "INSERT_DOOR_CANVASS_PASS",
    data,
  };
};

export const setCampaignDoorCanvassPassesLoading = (data) => {
  return {
    type: "SET_CAMPAIGN_DOOR_CANVASS_PASSES_LOADING",
    data,
  };
};

export const setCampaignDoorCanvassPassesError = (data) => {
  return {
    type: "SET_CAMPAIGN_DOOR_CANVASS_PASSES_ERROR",
    data,
  };
};

// DOOR CREWS
export const setDoorCrews = (data) => {
  return {
    type: "SET_DOOR_CREWS",
    data,
  };
};

export const setDoorCrewsShiftData = (data) => {
  return {
    type: "SET_DOOR_CREWS_SHIFT_DATA",
    data,
  };
};

export const setDoorCrewsLoading = (data) => {
  return {
    type: "SET_DOOR_CREWS_LOADING",
    data,
  };
};

export const setDoorCrewsError = (data) => {
  return {
    type: "SET_DOOR_CREWS_ERROR",
    data,
  };
};

export const insertDoorCrew = (data) => {
  return {
    type: "INSERT_DOOR_CREW",
    data,
  };
};

//data is crew id
export const removeDoorCrew = (data) => {
  return {
    type: "REMOVE_DOOR_CREW",
    data,
  };
};

export const updateDoorCrew = (data) => {
  return {
    type: "UPDATE_DOOR_CREW",
    data,
  };
};

export const setTurfCodes = (data) => {
  return {
    type: "SET_TURF_CODES",
    data,
  };
};

export const setTurfCodesError = (data) => {
  return {
    type: "SET_TURF_CODES_ERROR",
    data,
  };
};

export const setTurfCodesLoading = (data) => {
  return {
    type: "SET_TURF_CODES_LOADING",
    data,
  };
};

export const setAssignedSites = (data) => {
  return {
    type: "SET_ASSIGNED_SITES",
    data,
  };
};

export const setAssignedSitesCallParams = (data) => {
  return {
    type: "SET_ASSIGNED_SITES_CALL_PARAMS",
    data,
  };
};

export const setAssignedSitesLoading = (data) => {
  return {
    type: "SET_ASSIGNED_SITES_LOADING",
    data,
  };
};

export const setAssignedSitesError = (data) => {
  return {
    type: "SET_ASSIGNED_SITES_ERROR",
    data,
  };
};

export const setAssignedTurfs = (data) => {
  return {
    type: "SET_ASSIGNED_TURFS",
    data,
  };
};

export const setAssignedTurfsCallParams = (data) => {
  return {
    type: "SET_ASSIGNED_TURFS_CALL_PARAMS",
    data,
  };
};

export const setAssignedTurfsLoading = (data) => {
  return {
    type: "SET_ASSIGNED_TURFS_LOADING",
    data,
  };
};

export const setAssignedTurfsError = (data) => {
  return {
    type: "SET_ASSIGNED_TURFS_ERROR",
    data,
  };
};

export const setDashboardParams = (data) => {
  return {
    type: "SET_DASHBOARD_PARAM",
    data,
  };
};

export const setDashboardOptions = (data) => {
  return {
    type: "SET_DASHBOARD_OPTIONS",
    data,
  };
};

export const clearDashboardOptions = () => {
  return {
    type: "RESET_DASHBOARD_PARAMS",
  };
};

export const setSiteNoteCategories = (data) => {
  return {
    type: "SET_SITE_NOTE_CATEGORIES",
    data,
  };
};

export const setSiteNotes = (data) => {
  return {
    type: "SET_SITE_NOTES",
    data,
  };
};

export const setSiteNotesLoading = (data) => {
  return {
    type: "SET_SITE_NOTES_LOADING",
    data,
  };
};

export const setSiteNotesError = (data) => {
  return {
    type: "SET_SITE_NOTES_ERROR",
    data,
  };
};

//alert variables

/*
*   case 'SET_ALERT_CONFIGURATIONS':
            return {...state, data: action.data}


        case 'UPDATE_ALERT_CONFIGURATION':
            data = [...state.data];
            target = data.findIndex(d => d.id === action.data.id)
            if (target > -1) {
                data[target] = action.data
            }
            return {...state, data}

        case 'REMOVE_ALERT_CONFIGURATION':
            data = [...state.data];
            target = data.findIndex(d => d.id === action.data.id)
            if (target > -1) {
                data.splice(target, 1)
            }
            return {...state, data}

        case 'ADD_ALERT_CONFIGURATION':
            return {...state, data: [...state.data, action.data]}

        case 'SET_ALERT_WEBHOOKS':
            return {...state, webhooks: action.data}

        case 'UPDATE_ALERT_WEBHOOK':
            data = [...state.webhooks];
            target = data.findIndex(d => d.id === action.data.id)
            if (target > -1) {
                data[target] = action.data
            }
            return {...state, webhooks: data}


        case 'REMOVE_ALERT_WEBHOOK':
            data = [...state.webhooks];
            target = data.findIndex(d => d.id === action.data.id)
            if (target > -1) {
                data.splice(target, 1)
            }
            return {...state, webhooks: data}

        case 'ADD_ALERT_WEBHOOK':
            return {...state, webhooks: [...state.webhooks, action.data]}

        case 'SET_ALERT_CONFIGS_LOADING':
            return {
                ...state,
                loading: action.data
            }

        case 'SET_ALERT_CONFIGS_ERROR':
            return {
                ...state,
                error: action.data
            }

        default:
            return state

*
* */

export const setAlertConfigs = (data) => {
  return {
    type: "SET_ALERT_CONFIGS",
    data,
  };
};

export const setAlertConfigsLoading = (data) => {
  return {
    type: "SET_ALERT_CONFIGS_LOADING",
    data,
  };
};

export const setAlertConfigsError = (data) => {
  return {
    type: "SET_ALERT_CONFIGS_ERROR",
    data,
  };
};

export const removeAlertConfig = (data) => {
  return {
    type: "REMOVE_ALERT_CONFIG",
    data,
  };
};

export const addAlertConfig = (data) => {
  return {
    type: "ADD_ALERT_CONFIG",
    data,
  };
};

export const updateAlertConfig = (data) => {
  return {
    type: "UPDATE_ALERT_CONFIG",
    data,
  };
};

export const addAlertConfigWebhook = (data) => {
  return {
    type: "ADD_ALERT_CONFIG_WEBHOOK",
    data,
  };
};

export const removeAlertConfigWebhook = (data) => {
  return {
    type: "REMOVE_ALERT_CONFIG_WEBHOOK",
    data,
  };
};

export const updateAlertConfigWebhook = (data) => {
  return {
    type: "UPDATE_ALERT_CONFIG_WEBHOOK",
    data,
  };
};

export const setAlertWebhooks = (data) => {
  return {
    type: "SET_ALERT_WEBHOOKS",
    data,
  };
};

export const removeAlertWebhook = (data) => {
  return {
    type: "REMOVE_ALERT_WEBHOOK",
    data,
  };
};

export const addAlertWebhook = (data) => {
  return {
    type: "ADD_ALERT_WEBHOOK",
    data,
  };
};

export const updateAlertWebhook = (data) => {
  return {
    type: "UPDATE_ALERT_WEBHOOK",
    data,
  };
};
